<template>
    <v-card flat class="ma-5">
        <v-card-title>
            <v-row>
                <v-col cols="12" md="3">
                    <input-date-picker :setup.sync="datePickers.fromDate"></input-date-picker>
                </v-col>
                <v-col cols="12" md="3">
                    <input-date-picker :setup.sync="datePickers.toDate"></input-date-picker>
                </v-col>

                <v-divider
                    class="mx-3 hidden-md-and-down mt-0"
                    inset
                    vertical
                ></v-divider>

                <v-col cols="12" md="4">
                    <input-auto-complete :setup.sync="selects.responsible"></input-auto-complete>
                </v-col>

                <v-divider
                    class="mx-3 hidden-md-and-down mt-0"
                    inset
                    vertical
                ></v-divider>

                <v-col cols="12" md="1">
                    <v-btn
                        :loading="loading"
                        :disabled="loading"
                        class="ml-1"
                        color="purple"
                        :dark="!loading"
                        block
                        @click.prevent="loadData()"
                    >
                        {{ $t('common.update') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <data-table :setup.sync="dataTable" @delete-item="deleteItem"></data-table>
    </v-card>
</template>

<script>
import API from '@/api'
import InputDatePicker from '@/components/InputDatePicker'
import InputAutoComplete from '@/components/InputAutoComplete'
import DataTable from '@/components/DataTable'

export default {
    name: 'detail-tab-workedhour',
    components: {
        InputDatePicker,
        InputAutoComplete,
        DataTable
    },
    data: function () {
        return {
            loading: true,
            datePickers: {
                fromDate: {
                    label: this.$t('client.workedHours.fromDate'),
                    clearable: true,
                    dateFormatted: undefined,
                    hideDetails: true
                },
                toDate: {
                    label: this.$t('client.workedHours.toDate'),
                    clearable: true,
                    dateFormatted: undefined,
                    hideDetails: true
                }
            },
            selects: {
                responsible: {
                    label: this.$t('client.workedHours.responsible'),
                    text: 'user.name',
                    value: 'objectId',
                    icon: 'person',
                    multiple: true,
                    clearable: true,
                    hideDetails: true,
                    items: [],
                    selectedItems: []
                }
            },
            dataTable: {
                loading: true,
                itemName: this.$t('client.workedHours.dataTable.itemName'),
                headers: [
                    {
                        text: this.$t('client.workedHours.dataTable.headers.registeredAt'),
                        value: 'registeredAt',
                        width: '15%',
                        align: 'center',
                        date: 'iso'
                    },
                    { text: this.$t('client.workedHours.dataTable.headers.demand'), value: 'demand.demand', width: '35%' },
                    { text: this.$t('client.workedHours.dataTable.headers.workedHour'), value: 'workedHour', width: '20%', align: 'center' },
                    {
                        text: this.$t('client.workedHours.dataTable.headers.responsibleName'),
                        value: 'responsible.user.name',
                        width: '15%',
                        align: 'center',
                        background: 'responsible.color'
                    },
                    {
                        text: this.$t('client.workedHours.dataTable.headers.actions'),
                        value: 'actions',
                        align: 'center',
                        sortable: false,
                        edit: false,
                        delete: true,
                        width: '15%'
                    }
                ],
                items: [],
                totalItems: 0,
                requesterType: 'departamentos',
                requesterId: undefined,
                requesterItemId: 'demand.objectId',
                detailTo: 'DetalheDemanda',
                editTo: 'EditarDemanda',
                pagination: {
                    multiSort: true,
                    mustSort: false,
                    page: 1,
                    itemsPerPage: 500,
                    groupBy: [],
                    groupDesc: [],
                    sortBy: ['registeredAt'],
                    sortDesc: [true],
                    sortFormated: [{ value: 'registeredAt', descending: true }]
                },
                sortingTimeout: undefined,
                footerProps: {
                    itemsPerPageOptions: [500, 250, 100, 50, 25, 10]
                }
            }
        }
    },
    watch: {
        'dataTable.pagination.sortBy': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.dataTable.sortingTimeout !== undefined) clearTimeout(this.dataTable.sortingTimeout)
                    this.dataTable.sortingTimeout = setTimeout(() => {
                        let sortView = {
                            order: this.dataTable.pagination.sortFormated
                        }
                        this.$helpers.setClientSortWorkedHourView(sortView)
                        this.loadData()
                    }, 1000)
                }
            },
            deep: true
        },
        'dataTable.pagination.page': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        },
        'dataTable.pagination.itemsPerPage': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    this.loadData()
                }
            },
            deep: true
        }
    },
    mounted () {
        // if (window.getApp.refreshWorkedHour) {
        //     this.loadData()
        // }
        this.getAllEmployee()
        this.loadData()
    },
    methods: {
        getSortFormated (sortArray) {
            const sortFormated = sortArray.map((sortObj) => {
                if (sortObj.value === 'demand') sortObj.value = 'demandName'
                if (sortObj.value === 'responsible') sortObj.value = 'responsibleName'
                return `${(sortObj.descending) ? '-' : ''}${sortObj.value}`
            })
            return sortFormated.join()
        },
        async getAllEmployee () {
            this.selects.responsible.items = await this.$helpers.getAllEmployee()
        },
        async loadData () {
            await this.$helpers.sleep(0)
            window.getApp.refreshWorkedHour = false
            this.loading = true
            this.dataTable.loading = true
            this.dataTable.items = []
            this.dataTable.requesterId = this.$route.params.id
            const endpoint = API.EndPoints.getDemandWorkedHour
            const where = {
                client: {
                    __type: 'Pointer',
                    className: 'Client',
                    objectId: this.$route.params.id
                }
            }

            if (this.datePickers.fromDate.dateFormatted || this.datePickers.toDate.dateFormatted) {
                where['registeredAt'] = {}
            }

            if (this.datePickers.fromDate.dateFormatted) {
                where.registeredAt['$gte'] = {
                    __type: 'Date',
                    iso: new Date(this.datePickers.fromDate.dateFormatted.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')).toISOString()
                }
            }

            if (this.datePickers.toDate.dateFormatted) {
                where.registeredAt['$lte'] = {
                    __type: 'Date',
                    iso: new Date(this.datePickers.toDate.dateFormatted.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1')).toISOString()
                }
            }

            if (this.selects.responsible.selectedItems.length > 0) {
                where['responsible'] = {}
                where.responsible['$in'] = this.selects.responsible.selectedItems.map((responsible) => {
                    return {
                        __type: 'Pointer',
                        className: 'UserCompany',
                        objectId: responsible
                    }
                })
            }

            let sortView = JSON.parse(localStorage.getItem('clientSortWorkedHour'))

            if (sortView === null) {
                sortView = {
                    order: this.dataTable.pagination.sortFormated
                }
            }

            const params = {
                limit: this.dataTable.pagination.itemsPerPage,
                skip: (this.dataTable.pagination.page - 1) * this.dataTable.pagination.itemsPerPage,
                count: true,
                order: this.getSortFormated(sortView.order),
                where: JSON.stringify(where),
                include: ['demand', 'responsible', 'responsible.user']
            }

            new API(endpoint, params).request().then(response => {
                this.$helpers.setClientSortWorkedHourView(sortView)
                this.dataTable.items = response.body.results
                this.dataTable.totalItems = response.body.count
                this.loading = false
                this.dataTable.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        async deleteItem (item) {
            let endpoint = API.EndPoints.deleteDemandWorkedHour
            endpoint.id = item.objectId
            let msg = ''
            await new API(endpoint).request()
                .then(
                    (response) => { msg = this.$t('client.workedHours.dataTable.deleteSuccess') },
                    (error) => { msg = (error.status !== 0) ? error.data.error : '' }
                )
            if (msg !== '') alert(msg)
            this.loadData()
        }
    }
}
</script>
